import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, isDevMode, } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from "@angular/router";
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AppComponent } from './app.component';
import { APP_DATE_FORMATS, CoreModule } from './core/core.module';
import { GroupModule } from './group/group.module';
import { HistoryModule } from './history/history.module';
import { HomeModule } from './home/home.module';
import { PatientModule } from './patient/patient.module';
import { PendingModule } from './pending/pending.module';
import { StatisticsModule } from './statistics/statistics.module';
import { ErrorInterceptorService } from './services/error-interceptor.service';
import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MedpraxProxyInterceptor } from './core/interceptors/medprax-proxy.interceptor';
import { RetryInterceptor } from './core/interceptors/retry.interceptor';
import { environment } from '../environments/environment';
//import * as Sentry from "@sentry/angular";


@NgModule({
  declarations: [
    AppComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    HomeModule,
    HistoryModule,
    PendingModule,
    UserModule,
    SharedModule,
    GroupModule,
    PatientModule,
    StatisticsModule,
    MatMomentDateModule,
    MatCheckboxModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode() && (environment as any).isNative !== true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    ErrorInterceptorService,
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    /*  {
       provide: HTTP_INTERCEPTORS,
       useClass: MedpraxAuthInterceptor,
       multi: true
     }, */
    /* {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    }, */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MedpraxProxyInterceptor,
      multi: true
    },
    /* {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true
    } */
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
